export const SET_CART_DISCOUNT = 'SET_CART_DISCOUNT'
export const SET_CART_DISCOUNT_TYPE = 'SET_CART_DISCOUNT_TYPE'
export const SET_CART_INITIAL_DISCOUNT = 'SET_CART_INITIAL_DISCOUNT'
export const SET_CART_EXTRA_DISCOUNT = 'SET_CART_EXTRA_DISCOUNT'
export const SET_CART_EXTRA_DISCOUNT_TYPE = 'SET_CART_EXTRA_DISCOUNT_TYPE'
export const SET_CATEGORY_DISCOUNT_CONFIG = 'SET_CATEGORY_DISCOUNT_CONFIG'
